import useStore from "../../store";
import MaterialIcon from "../MaterialIcon/MaterialIcon";
import { useNavigateWithVars } from "../../hooks/useNavigateWithVars";
import "./HintButton.css";

const HintButton = ({}) => {
  const navigateTo = useNavigateWithVars();
  const getLocalized = useStore((state) => state.getLocalized);
  const showHintTooltip = useStore((state) => state.showHintTooltip);
  return (
    <div className="HintButton">
      <MaterialIcon
        className="icon"
        name="mystery"
        onClick={() => navigateTo("/hints/")}
      />
      <span className="HintLabel">{getLocalized("texts", "Hinweise")}</span>
      <div className={`tooltip${showHintTooltip ? " show" : ""}`}>
        <span className="tooltiptext">
          {getLocalized("texts", "HinweisTooltip")}
        </span>
      </div>
    </div>
  );
};
export default HintButton;
